import { putJaSalaryText } from '~/lib/utils';
import { Panel } from '~/components/panel';

interface SalaryChartProps {
  conditionText: string;
  bins: number[];
  freqs_ratio: number[];
  salary_ave_total: number;
  jobs_total: number;
}

export function SalaryChart(props: SalaryChartProps) {
  if (props.jobs_total === 0) {
    return null;
  }
  const title = props.conditionText
    ? props.conditionText.replaceAll('/', 'の')
    : 'すべて';
  const salaryTitle =
    props.jobs_total >= 20
      ? title + 'の求人年収分布(万円)'
      : title + 'の求人年収(万円)';
  return (
    <Panel title={putJaSalaryText(salaryTitle)} isSidebar>
      <div className="u-p10"></div>
      {props.jobs_total >= 20 && props.bins.length > 0 && (
        <div className="p-job-search__salary__chart">
          {props.bins.map((bin, i) => (
            <div key={i} className="p-job-search__salary__chart__vertical">
              <div
                className={`p-job-search__salary__chart__graph u-hp${props.freqs_ratio[i]}`}
              >
                <div
                  className={`p-job-search__salary__chart__label ${
                    props.bins.length > 7 ? '-rotate' : ''
                  }`}
                >
                  {bin}
                </div>
              </div>
            </div>
          ))}
        </div>
      )}
      <div className="p-job-search__salary__average">
        {'平均年収: ' + props.salary_ave_total + '万円'}
      </div>
    </Panel>
  );
}
